import { render } from "./Loading.vue?vue&type=template&id=2c130e9a"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=2c130e9a&lang=scss"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__